// extracted by mini-css-extract-plugin
export default {"table-loader__container":"styles_table-loader__container__gycSq","table-loader__box--icon":"styles_table-loader__box--icon__GuRvb","rotate":"styles_rotate__UMA2W"};